/**
 * Search object del flujo Holiday Weeks (/holidaylist).
 *
 * Espejo de "searchWeek" (sesions.js) pero para busqueda holiday-first: el
 * holiday es el campo principal y el destino es opcional. NO toca "searchWeek":
 * el flujo resortlist actual queda intacto.
 *
 * La query solo siembra la entrada (igual que searchWeek): si llega
 * `query.holiday` se resuelve y persiste; si no, se devuelve lo almacenado
 * (vuelta del detalle, filtros aplicados, paginacion).
 */

const STORAGE_KEY = "searchHoliday";

const setSearchHolidayObject = (obj) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
};

const todayIso = () => new Date().toISOString().slice(0, 10);

/** Horizonte de la vitrina: hoy + 12 meses (ISO). */
const horizonIso = () => {
  const d = new Date();
  d.setMonth(d.getMonth() + 12);
  return d.toISOString().slice(0, 10);
};

const resolveFromQuery = (query = {}) => ({
  holiday: query.holiday || null, // token | 'all' | null (hub/vitrina)
  year: query.year ? parseInt(query.year, 10) : null,
  country: query.country || null,
  city: query.city ? String(query.city).split(",") : [],
  occupancy: query.occupancy ? parseInt(query.occupancy, 10) : null,
  priceMin: query.priceMin != null && query.priceMin !== "" ? query.priceMin : null,
  priceMax: query.priceMax != null && query.priceMax !== "" ? query.priceMax : null,
  rating: query.rating || null,
  checkInDates: query.checkInDates ? String(query.checkInDates).split(",") : [],
  unitType: query.unitType ? String(query.unitType).split(",") : [],
  holidayTokens: [],
  view: query.view === "dest" ? "dest" : "list",
  sort: query.sort === "dest" ? "dest" : "ci",
  page: query.page ? parseInt(query.page, 10) : 1,
  limit: 10,
});

const getSearchHolidayObject = (query = {}) => {
  if (query.holiday) {
    const resolved = resolveFromQuery(query);
    setSearchHolidayObject(resolved);
    return resolved;
  }
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : null;
};

/** modo 'hub' (vitrina) | 'results' (holiday o any holiday) */
const modeOf = (search) => (search && search.holiday ? "results" : "hub");

/**
 * Ventana de check-in de la busqueda:
 * - holiday especifico: su ventana del catalogo, sin contar check-ins ya vencidos
 * - any holiday: horizonte de 12 meses desde hoy
 */
const checkInWindow = (search, occurrence) => {
  if (search.holiday !== "all" && occurrence) {
    return { from: occurrence.from > todayIso() ? occurrence.from : todayIso(), to: occurrence.to };
  }
  return { from: todayIso(), to: horizonIso() };
};

module.exports = {
  setSearchHolidayObject,
  getSearchHolidayObject,
  modeOf,
  todayIso,
  horizonIso,
  checkInWindow,
};
